module.exports = __webpack_public_path__ + "static/media/earthTop.e4574391.mp4";